/* eslint-disable import/no-duplicates */
import { add, format, getTime, formatDistanceToNow } from 'date-fns';

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string, locale?: Locale) {
  const fm = newFormat ?? 'dd MMM yyyy';

  // resolve problem with fuse in date-fns
  return date
    ? format(
        add(new Date(date), {
          hours: 3,
        }),
        fm,
        { locale }
      )
    : '';
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat ?? 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function fDateDMY(date: InputValue, locale?: Locale) {
  const fm = 'dd/MM/yyyy';

  return date
    ? format(
        add(new Date(date), {
          hours: 3,
        }),
        fm,
        { locale }
      )
    : '';
}
